// extracted by mini-css-extract-plugin
export default {"main":"style_main__WbQVM","wb":"style_wb__xJOxp","sub":"style_sub__cAf6M"};